/** Derive setup step progress for the chat shell from onboarding BFF payloads. */

import type {
  OnboardingSourcesResponse,
  OnboardingWarehouseResponse,
} from "@/types/onboarding.types";

export const ONBOARDING_SETUP_STEP_COUNT = 2;

export function countOnboardingSetupStepsComplete(
  warehouse?: OnboardingWarehouseResponse,
  sources?: OnboardingSourcesResponse,
  wizardCompleted?: boolean,
): number {
  let completed = 0;
  if (warehouse?.warehouse.connected) {
    completed += 1;
  }
  const anySourceConnected = [...(sources?.pulse.sources ?? []), ...(sources?.daton.sources ?? [])].some(
    (chip) => chip.connected === true,
  );
  if (wizardCompleted || anySourceConnected) {
    completed += 1;
  }
  return Math.min(completed, ONBOARDING_SETUP_STEP_COUNT);
}
